import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WorkflowIdPage.GeneralConditionCell', {
    anyFieldName: 'Any {fieldName}',
    fieldNameMatches: '{fieldName} matches',
    fieldNameDoesNotMatch: '{fieldName} does not match',
    selectFieldName: 'Select {fieldName}',
});
